// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   CramMapModal
   Overlay + bordered panel that portals into .deck-map-area. Hosts
   CramSession (.ls-page) or ConceptBlockDrill (.cbd-page) unchanged;
   the scoped overrides below shed the full-page chrome those pages
   mount for their standalone route.
   Accent: indigo #6366f1 — matches --cram-cat-color's default.
   ------------------------------------------------------------------ */

.crmm-viewport {
  position: absolute;
  inset: 0;
  z-index: 100;
  container-type: inline-size;
}

body > .crmm-viewport {
  position: fixed;
}

.crmm-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  padding: 28px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background: rgba(8, 6, 16, 0.58);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: crmm-overlay-in 160ms ease-out;
}

/* Fallback mount (document.body): full-viewport fixed overlay so the
   modal still renders when the map hasn't mounted yet. */
body > .crmm-overlay {
  position: fixed;
  padding: 40px;
}

.crmm-panel {
  --crmm-close-reserve: 56px;
  --crmm-session-pad-x: 20px;
  --crmm-bundle-pad-x: 1.25rem;
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: rgba(10, 10, 14, 0.96);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 10px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.62),
    inset 0 0 0 1px rgba(99, 102, 241, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow: hidden;
  animation: crmm-panel-in 220ms cubic-bezier(0.34, 1.2, 0.5, 1);
}

.crmm-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.32);
  border-radius: 8px;
  color: rgba(165, 180, 252, 0.94);
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}

.crmm-close:hover {
  background: rgba(99, 102, 241, 0.26);
  border-color: rgba(99, 102, 241, 0.58);
  color: #fff;
}

.crmm-close:focus-visible {
  outline: 2px solid rgba(165, 180, 252, 0.9);
  outline-offset: 2px;
}

.crmm-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Embedded session pages ──
   CramSession (.ls-page) and ConceptBlockDrill (.cbd-page) both default
   to min-height: 100vh with their own opaque backgrounds. Inside the
   modal they should hug the panel instead. */
.crmm-body .ls-page,
.crmm-body .cbd-page {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none;
  overflow: hidden;
}

/* Page header — keep sticky, but darken so it reads against the panel
   and pad the right side for the close X. */
.crmm-body .ls-header,
.crmm-body .cbd-topbar {
  padding-right: var(--crmm-close-reserve);
  background: rgba(10, 10, 14, 0.94);
}

/* Page-level back buttons are redundant — the close X is the exit. */
.crmm-body .ls-back,
.crmm-body .cbd-topbar-back {
  display: none;
}

/* Scroll containers fill the panel and lose their standalone width caps. */
.crmm-body .ls-container,
.crmm-body .cbd-bundle-wrap {
  flex: 1 1 auto;
  min-height: 0;
  max-width: none;
  width: 100%;
  overflow-y: auto;
}

.crmm-body .ls-container {
  padding: 18px var(--crmm-session-pad-x) 24px;
}

.crmm-body .cbd-bundle-wrap {
  padding: 1rem var(--crmm-bundle-pad-x) 6rem;
}

/* CramSession's category strip should span the modal, not its narrow
   68rem container. Darken the wrap so the sticky strip reads. */
.crmm-body .cram-tabs-wrap {
  background: rgba(10, 10, 14, 0.94);
}

.crmm-body .cram-tabs {
  max-width: none;
}

/* The shared UserActionBar strip is already visible on the dashboard
   behind the modal — dedupe it inside the modal. */
.crmm-body .exam-tabs-bar {
  display: none;
}

@keyframes crmm-overlay-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes crmm-panel-in {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}

@container (max-width: 1800px) {
  .crmm-overlay {
    padding: clamp(18px, 1.55cqi, 28px);
  }

  .crmm-panel {
    --crmm-close-reserve: clamp(48px, 3.2cqi, 56px);
    --crmm-session-pad-x: clamp(16px, 1.25cqi, 20px);
    --crmm-bundle-pad-x: clamp(1rem, 1.25cqi, 1.25rem);
  }
}

@container (max-width: 640px) {
  .crmm-overlay { padding: 16px; }
  .crmm-body .ls-header,
  .crmm-body .cbd-topbar { padding-right: 48px; }
  .crmm-body .ls-container,
  .crmm-body .cbd-bundle-wrap {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

body > .crmm-viewport .crmm-overlay {
  padding: 40px;
}

@media (max-width: 640px) {
  body > .crmm-overlay,
  body > .crmm-viewport .crmm-overlay {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CramMapModal/CramMapModal.css"],"names":[],"mappings":"AAAA;;;;;;;uEAOuE;;AAEvE;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;yDACyD;AACzD;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,yCAAyC;EACzC,mBAAmB;EACnB;;4CAE0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;6CAG6C;AAC7C;;EAEE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;4CAC4C;AAC5C;;EAEE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;;EAEE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;;EAEE,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;gEACgE;AAChE;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;mDACmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,+CAA+C;IAC/C,gDAAgD;IAChD,kDAAkD;EACpD;AACF;;AAEA;EACE,gBAAgB,aAAa,EAAE;EAC/B;2BACyB,mBAAmB,EAAE;EAC9C;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ------------------------------------------------------------------\n   CramMapModal\n   Overlay + bordered panel that portals into .deck-map-area. Hosts\n   CramSession (.ls-page) or ConceptBlockDrill (.cbd-page) unchanged;\n   the scoped overrides below shed the full-page chrome those pages\n   mount for their standalone route.\n   Accent: indigo #6366f1 — matches --cram-cat-color's default.\n   ------------------------------------------------------------------ */\n\n.crmm-viewport {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  container-type: inline-size;\n}\n\nbody > .crmm-viewport {\n  position: fixed;\n}\n\n.crmm-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  padding: 28px;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  background: rgba(8, 6, 16, 0.58);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: crmm-overlay-in 160ms ease-out;\n}\n\n/* Fallback mount (document.body): full-viewport fixed overlay so the\n   modal still renders when the map hasn't mounted yet. */\nbody > .crmm-overlay {\n  position: fixed;\n  padding: 40px;\n}\n\n.crmm-panel {\n  --crmm-close-reserve: 56px;\n  --crmm-session-pad-x: 20px;\n  --crmm-bundle-pad-x: 1.25rem;\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: rgba(10, 10, 14, 0.96);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 10px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.62),\n    inset 0 0 0 1px rgba(99, 102, 241, 0.06);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  overflow: hidden;\n  animation: crmm-panel-in 220ms cubic-bezier(0.34, 1.2, 0.5, 1);\n}\n\n.crmm-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 5;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(99, 102, 241, 0.12);\n  border: 1px solid rgba(99, 102, 241, 0.32);\n  border-radius: 8px;\n  color: rgba(165, 180, 252, 0.94);\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.crmm-close:hover {\n  background: rgba(99, 102, 241, 0.26);\n  border-color: rgba(99, 102, 241, 0.58);\n  color: #fff;\n}\n\n.crmm-close:focus-visible {\n  outline: 2px solid rgba(165, 180, 252, 0.9);\n  outline-offset: 2px;\n}\n\n.crmm-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── Embedded session pages ──\n   CramSession (.ls-page) and ConceptBlockDrill (.cbd-page) both default\n   to min-height: 100vh with their own opaque backgrounds. Inside the\n   modal they should hug the panel instead. */\n.crmm-body .ls-page,\n.crmm-body .cbd-page {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  border: none;\n  overflow: hidden;\n}\n\n/* Page header — keep sticky, but darken so it reads against the panel\n   and pad the right side for the close X. */\n.crmm-body .ls-header,\n.crmm-body .cbd-topbar {\n  padding-right: var(--crmm-close-reserve);\n  background: rgba(10, 10, 14, 0.94);\n}\n\n/* Page-level back buttons are redundant — the close X is the exit. */\n.crmm-body .ls-back,\n.crmm-body .cbd-topbar-back {\n  display: none;\n}\n\n/* Scroll containers fill the panel and lose their standalone width caps. */\n.crmm-body .ls-container,\n.crmm-body .cbd-bundle-wrap {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-width: none;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.crmm-body .ls-container {\n  padding: 18px var(--crmm-session-pad-x) 24px;\n}\n\n.crmm-body .cbd-bundle-wrap {\n  padding: 1rem var(--crmm-bundle-pad-x) 6rem;\n}\n\n/* CramSession's category strip should span the modal, not its narrow\n   68rem container. Darken the wrap so the sticky strip reads. */\n.crmm-body .cram-tabs-wrap {\n  background: rgba(10, 10, 14, 0.94);\n}\n\n.crmm-body .cram-tabs {\n  max-width: none;\n}\n\n/* The shared UserActionBar strip is already visible on the dashboard\n   behind the modal — dedupe it inside the modal. */\n.crmm-body .exam-tabs-bar {\n  display: none;\n}\n\n@keyframes crmm-overlay-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes crmm-panel-in {\n  from { opacity: 0; transform: scale(0.98); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n@container (max-width: 1800px) {\n  .crmm-overlay {\n    padding: clamp(18px, 1.55cqi, 28px);\n  }\n\n  .crmm-panel {\n    --crmm-close-reserve: clamp(48px, 3.2cqi, 56px);\n    --crmm-session-pad-x: clamp(16px, 1.25cqi, 20px);\n    --crmm-bundle-pad-x: clamp(1rem, 1.25cqi, 1.25rem);\n  }\n}\n\n@container (max-width: 640px) {\n  .crmm-overlay { padding: 16px; }\n  .crmm-body .ls-header,\n  .crmm-body .cbd-topbar { padding-right: 48px; }\n  .crmm-body .ls-container,\n  .crmm-body .cbd-bundle-wrap {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\nbody > .crmm-viewport .crmm-overlay {\n  padding: 40px;\n}\n\n@media (max-width: 640px) {\n  body > .crmm-overlay,\n  body > .crmm-viewport .crmm-overlay {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
